import { render, staticRenderFns } from "./addquchonggroup.vue?vue&type=template&id=75abfc1f&scoped=true&"
import script from "./addquchonggroup.vue?vue&type=script&lang=js&"
export * from "./addquchonggroup.vue?vue&type=script&lang=js&"
import style0 from "./addquchonggroup.vue?vue&type=style&index=0&id=75abfc1f&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75abfc1f",
  null
  
)

export default component.exports